import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=add21e6c&lang=pug&"
import script from "./Roles.vue?vue&type=script&lang=js&"
export * from "./Roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports